import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDownloadActivityData = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadActivityData = async ({ organisationId }: { organisationId: string }) => {
    const response = await fetch(
      `${APIBaseChronos}/api/usage/activity/download`,
      getFetchConfig({ method: FetchMethod.POST, data: { organisationId } }),
    );
    if (!response.ok) throw new Error('Failed to download activity data');

    const blob = await response.blob();
    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: 'wexler-activity.xlsx',
    });
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading } = useMutation(downloadActivityData, {
    onSuccess: () => {
      trackCustomEvent(TrackingEventsV2.UsageDashboardDownloadData);
    },
    onError: () => {
      toast.error('Failed to download activity data. Please try again.');
    },
  });

  return { fetchDownload, isLoading };
};
